<template>
  <div class="confirm">
    <el-row type="flex" align="middle">
      <div style="margin-right: 0.48vw;">
        <el-button type="primary" @click="Warehousing">入库</el-button>
        <el-button type="primary" @click="unkonwnClick">未知记录</el-button>
      </div>
      <el-radio-group v-model="pageRadio" size="small" @change="changeRadio">
        <el-radio-button label="1">订单核对</el-radio-button>
        <el-radio-button label="2">库存核对</el-radio-button>
      </el-radio-group>
    </el-row>
    <el-form class="custom-formScreen" :model="formScreen" label-width="4.8vw" inline ref="formScreen">
      <el-form-item label="信息状态" prop="orderInfoStatus" style="width: 40%" v-show="pageRadio === '1'">
        <el-radio-group v-model="formScreen.orderInfoStatus">
          <el-radio :label="1">正常</el-radio>
          <el-radio :label="2">等件</el-radio>
          <el-radio :label="3">异常</el-radio>
          <el-radio :label="4">拦截</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="分公司" prop="branchCompanyId">
        <el-select v-model="formScreen.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
          <el-option v-for="item in formData.listBranch" :key="item.id" :label="item.companyFullName"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="companyId">
        <el-select v-model="formScreen.companyId" filterable placeholder="请选择">
          <el-option v-for="item in formData.listSon" :key="item.id" :label="item.companyFullName"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTimeString">
        <el-date-picker v-model="formScreen.startTimeString" align="right" type="datetime" placeholder="选择开始日期"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTimeString">
        <el-date-picker v-model="formScreen.endTimeString" align="right" type="datetime" placeholder="选择结束日期"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="国内运单" prop="internalConveyNumber" v-show="pageRadio === '1'">
        <el-input v-model.trim="formScreen.internalConveyNumber" placeholder="请输入国内运单"></el-input>
      </el-form-item>
      <el-form-item label="国际运单" prop="conveyNumber" v-show="pageRadio === '1'">
        <el-input v-model.trim="formScreen.conveyNumber" placeholder="请输入国际运单"></el-input>
      </el-form-item>
      <el-form-item label="系统sku" prop="systemSku">
        <el-input v-model.trim="formScreen.systemSku" placeholder="请输入系统sku"></el-input>
      </el-form-item>
      <el-form-item label=" " prop="searchString" style="width: 30%">
        <el-input v-model.trim="formScreen.searchString" placeholder="订单号、订单ID"
          v-if="pageRadio === '1'"></el-input>
        <el-input v-model.trim="formScreen.searchString" placeholder="订单号、订单ID、国内单号" 
          v-else></el-input>
      </el-form-item>
      <el-form-item label=" " prop="searchStrs" style="width: 40%">
        <el-input v-model.trim="formScreen.searchStrs" placeholder="多个订单号，以空格分开" style="width: calc(100% - 220px)"
          v-if="pageRadio === '1'"></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm">搜索</el-button>
        <el-button type="primary" @click="resetForm">重置</el-button>
        <el-button type="warning" @click="openFixDialog">修复</el-button>
      </el-form-item>
    </el-form>
    <!-- S: 表格 订单核对 -->
    <el-row :gutter="20" v-show="estimatedQuantity" style="margin-bottom: 10px;">
      <el-col :span="4" :offset="0">
        <strong style="font-size: 14px">包裹预计数量：</strong>
        <el-input-number v-model="estimatedQuantity" size="small" :min="0" :step="1" disabled>
        </el-input-number>
        <span style="margin-left: 6px; font-size: 14px;">件</span>
      </el-col>
      <el-col :span="4" :offset="0">
        <strong style="font-size: 14px">包裹实际数量：</strong>
        <el-input-number v-model="receivedQuantity" size="small" :min="0" :step="1" :class="isReceivedQuantity?'red':''">
        </el-input-number>
        <span style="margin-left: 6px; font-size: 14px">件</span>
      </el-col>
      <el-col :span="4" :offset="0">
        <strong style="font-size: 14px">多：</strong>
        <el-input-number v-model="excessQuantity" size="small" :min="0" :step="1">
        </el-input-number>
        <span style="margin-left: 6px; font-size: 14px">件</span>
      </el-col>
      <el-col :span="5" :offset="0">
        <el-button type="primary" @click="saveQuantity" style="margin-left: -50px;">保存</el-button>
        <el-button type="primary" @click="openWeizhi" v-if="excessQuantity">未知</el-button>
      </el-col>
    </el-row>


    <el-table v-show="additional" :data="gridData">
      <el-table-column property="conveyNumber" label="物流编号" width="150" align="center">
      </el-table-column>
      <el-table-column property="logisticsCompany" label="物流公司" width="180" align="center">
      </el-table-column>
      <el-table-column property="estimatedQuantity" label="预计商品数量" width="130" align="center">
      </el-table-column>
       <el-table-column label="到货商品数量" width="130" align="center">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.receivedQuantity" controls-position="right" @change="handleChange(scope.row)" size="mini" :min="1" :max="1000"></el-input-number>
        </template>
      </el-table-column>
    </el-table>


    <el-table :data="listTable" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }"
      v-show="pageRadio === '1'" v-loading="loadingTable">
      <el-table-column prop="orderId" label="订单号/订单ID" align="left" width="240">
        <template slot-scope="scope">
          <div v-show="scope.row.orderNumber">订单编码：{{ scope.row.orderNumber }}</div>
          <div>订单号：{{ scope.row.amazonOrderId }}</div>
          <div>订单ID：{{ scope.row.orderId }}</div>
          <p v-if="scope.row.shipmentBoxId !== null && scope.row.shipmentBoxId !== ''">运输编号：{{ scope.row.shipmentBoxId
}}</p>
          <p style="display: flex;align-items: center;">
            <el-tag style="margin-right:5px;"
              :color="scope.row.orderType ? colorList4[scope.row.orderMark].itemName : '#fff'" effect="dark" size="mini"
              v-if="scope.row.orderMark">
              {{ scope.row.orderType ? colorList4[scope.row.orderMark].itemTypeName : '' }}
            </el-tag>
            <el-tag style="margin-right:5px;"
              :color="scope.row.orderType ? colorList5[scope.row.orderType].itemName : '#fff'" effect="dark" size="mini"
              v-if="scope.row.orderType">
              {{ scope.row.orderType ? colorList5[scope.row.orderType].itemTypeName : '' }}
            </el-tag>
            <el-tag v-if="scope.row.outInterceptStatus === 1" type="danger" effect="dark" size="mini">拦截</el-tag>
            <el-popover placement="top-start" title="物流内部备注" width="650" trigger="hover">
              <el-table :data="RemarkList" style="width: 100%">
                <el-table-column prop="roleName" label="添加人" width="120" align="center"></el-table-column>
                <el-table-column prop="remarkContent" label="内容" width="330" align="center"></el-table-column>
                <el-table-column prop="createTime" label="时间" width="200" align="center"></el-table-column>
              </el-table>
              <i class="el-icon-s-order" style="font-size:20px;" slot="reference"
                @mouseover="orderIdchange(scope.row)"></i>
            </el-popover>
            <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="scope.row.isFreeze === 1">
              <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
            </el-tooltip>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="订单信息" align="left">
        <template slot-scope="scope">
          <div class="details" v-for="(item, index) in scope.row.orderItems" :key="index">
            <div class="details_left">
              <el-popover trigger="hover" placement="right" prop="orderItems.imageUrl" v-if="item.imageUrl">
                <img style="width: 500px;height: 500px" :src="item.imageUrl" alt />
                <div class="scope_img" slot="reference">
                  <img :src="item.imageUrl" alt />
                </div>
              </el-popover>
              <el-button type="text" size="mini" v-else @click="getOriginalImg(item)"
                style="padding: 0;">查看原图</el-button>
            </div>
            <div class="details_right">
              <div style="width: 100%;">price: {{ item.itemAmount }} {{ item.itemCurrencyCode }}</div>
              <div style="width: 100%;color: red;" v-show="item.systemSku">系统SKU: {{ item.systemSku }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="quantityOfOrdered" label="数量" align="center" width="80">
        <template slot-scope="scope">
          <span style="font-weight: bold;color: red;">{{ scope.row.quantityOfOrdered }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="putStorageTime" label="入库时间" align="center" width="200"></el-table-column>
      <el-table-column label="国内运单" align="center" width="200">
        <template slot-scope="scope">
          <div v-for="item in scope.row.purchases" :key="item.id">
            <span v-if="![2, 7].includes(item.exceptionResult)">{{ item.internalConveyNumber }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="conveyNumber" label="国际运单" align="center" width="200">
        <template slot-scope="scope">
          <div v-for="item in scope.row.orderChannels" :key="item.id">{{ item.conveyNumber }}</div>
        </template>
      </el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <i class="el-icon-edit-outline fontSize-30" @click="edit(scope.row)"></i>
        </template>
      </el-table-column>
      <template slot="empty">
        <div style="padding: 20px 0;">
          <div style="color: #909399; margin-bottom: 10px; font-size: 14px;">暂无数据</div>
          <div style="color: #606266; font-size: 13px;">
            请尝试<span style="color: #409EFF; cursor: pointer; text-decoration: underline; font-weight: bold;" @click="openFixDialog">修复</span>
          </div>
        </div>
      </template>
    </el-table>
    <!-- E: 表格 订单核对 -->

    <!-- S: 表格 库存核对 -->
    <el-table :data="listTable2" border :header-cell-style="{ textAlign: 'center' }" v-show="pageRadio === '2'"
      v-loading="loadingTable2">
      <el-table-column prop="inventoryNumber" label="库存编号" align="center" width="240">
        <template slot-scope="scope">
          <p>库存号：{{ scope.row.inventoryNumber }}</p>
          <p>批次号：{{ scope.row.inventoryBatchNo }}</p>
        </template>
      </el-table-column>
      <el-table-column label="图片" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <img style="width: 500px;height: 500px;" :src="scope.row.imagesList[0]" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="productFullName" label="全称" align="center" width="200"></el-table-column>
      <el-table-column prop="productSimpleName" label="简称" align="center" width="200"></el-table-column>
      <el-table-column prop="internalConveyNumber" label="国内运单" align="center" width="200"></el-table-column>
      <el-table-column prop="putStorageTime" label="入库时间" align="center" width="200"></el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <i class="el-icon-edit-outline fontSize-30" @click="edit2(scope.row)"></i>
        </template>
      </el-table-column>
      <template slot="empty">
        <div style="padding: 20px 0;">
          <div style="color: #909399; margin-bottom: 10px; font-size: 14px;">暂无数据</div>
          <div style="color: #606266; font-size: 13px;">
            请尝试<span style="color: #409EFF; cursor: pointer; text-decoration: underline; font-weight: bold;" @click="openFixDialog">修复</span>
          </div>
        </div>
      </template>
    </el-table>
    <!-- E: 表格 库存核对 -->

    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[20, 50, 100, 200, 300]" :page-size="size" layout="total, sizes,prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>
    <!-- 入库 -->
    <Warehousing ref="Warehousing" @confirm="WarehousingConfirm" />
    <!-- 信息核对 -->
    <Informationcheck ref="Informationcheck" :bag-list="bagList" :UserInfo="UserInfo"
      @channelChangeConfirm="channelChangeConfirm" @channelChangeConfirm2="channelChangeConfirm2"
      v-if="renderComponent" />
    <!-- 未知记录 -->
    <el-dialog title="未知记录" :visible.sync="dialogTableVisible" width="40%" top="4vh">
      <el-table :data="listUnknown" border>
        <el-table-column property="internalConveyNumber" label="未知国内单号" align="center"></el-table-column>
        <el-table-column property="putStorageTime" label="入库时间" align="center"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="delUnknown(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="clearUnknown">清 空</el-button>
        <el-button type="primary" @click="dialogTableVisible = false">完 成</el-button>
      </span>
    </el-dialog>
    <!-- 未知记录 -->
    <el-dialog :visible.sync="originalVisible" width="540px">
      <img style="width: 500px;height: 500px;" :src="originalImg" alt />
    </el-dialog>

    <el-dialog title="未知提交" :visible.sync="dialogVisible" width="27%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="知会方：" prop="Notify">
          <el-select v-model="ruleForm.Notify" filterable placeholder="选择知会方" style="width:100%;">
            <el-option v-for="item in options" :key="item.id" :label="item.companyFullName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国内运单：" prop="DomesticWaybill">
          <el-input type="text" v-model="ruleForm.DomesticWaybill" placeholder="填写国内运单"></el-input>
        </el-form-item>
        <el-form-item label="未知说明：" prop="textarea">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="ruleForm.textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select :value="abnormalContent" @change="setExceptionRemark" style="width: 100%;" filterable>
            <el-option v-for="item in listAbnormalWords" :key="item.id" :label="item.typeName"
              :value="item.content"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-upload ref="upload" :action="action" list-type="picture-card" :on-success="handleAvatarSuccess"
          :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :headers="customHeaders">
          <i class="el-icon-plus" style="color: #0724ef;"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible1" append-to-body>
          <img width="100%" :src="dialogImageUrl1" alt />
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeWeizhi('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
      </span>
    </el-dialog>
    <!-- 修复弹窗 -->
    <el-dialog title="物流信息修复" :visible.sync="fixDialogVisible" width="30%">
      <el-form :model="fixForm" :rules="fixRules" ref="fixForm" label-width="100px">
        <el-form-item label="输入订单号" prop="orderNumber">
          <el-input v-model.trim="fixForm.orderNumber" placeholder="请输入订单号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fixDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="tryFix" :loading="fixLoading">尝试修复</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Warehousing from "./Warehousing"; //入库
import Informationcheck from "./Informationcheck";
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: "confirm",
  components: {
    Warehousing,
    Informationcheck,
  },
  data() {
    return {
      additional: false,
      gridData: [],
      pageRadio: '1',
      UserInfo: {},
      formScreen: {
        branchCompanyId: "",
        companyId: "",
        startTimeString: "",
        endTimeString: "",
        searchString: "",
        internalConveyNumber: "",
        conveyNumber: "",
        orderInfoStatus: '',
        systemSku: '',
        searchStrs: ''
      },
      formData: {
        listBranch: [],
        listSon: [],
        listChannel: [],
      },
      listTable: [],
      listTable2: [],
      page: 1,
      size: 20,
      total: 0,
      bagList: [],
      listUnknown: [],
      dialogTableVisible: false,
      originalImg: '',
      originalVisible: false,
      loadingTable: false,
      loadingTable2: false,
      RemarkList: [],
      renderComponent: false,
      colorList4: {},
      colorList5: {},
      estimatedQuantity: 0,
      estimatedId: '',
      receivedQuantity: 1,
      excessQuantity: 0,
      dialogVisible: false,
      ruleForm: {
        Notify: "",
        DomesticWaybill: "",
        textarea: "",
      },
      rules: {
        Notify: [
          { required: true, message: '请选择知会方', trigger: 'blur' },
        ],
        DomesticWaybill: [
          { required: true, message: '请填写国内运单', trigger: 'blur' },
        ],
        textarea: [
          { required: true, message: '请填写未知说明', trigger: 'blur' },
        ],
      },
      options: [],
      abnormalContent: '',
      listAbnormalWords: [],
      action: Baseurl + "imageController/uploadImage", customHeaders: { token: localStorage.getItem("token") },
      customHeaders: { token: localStorage.getItem("token") },
      imageData: [],
      arrimage: [],
      dialogVisible1: false,
      dialogImageUrl1: "",
      isReceivedQuantity: false,
      // 修复弹窗相关
      fixDialogVisible: false,
      fixLoading: false,
      fixForm: {
        orderNumber: ""
      },
      fixRules: {
        orderNumber: [
          { required: true, message: '请输入订单号', trigger: 'blur' },
        ]
      }
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    // 设置默认时间为近4月
    this.setDefaultDateRange();
    this.changeRadio()
    this.getBranchCompanyList();
    this.getBagList("")
    this.renderComponent = true;
    this.orderTag();
    this.ordertypeTag();
    ajaxPost(Baseurl + "unknownManageController/selectAllSubCompany").then(res => {
      this.options = res.data.data
    })
    ajaxPost(Baseurl + 'abnormalCommonWordController/selectAbnormalCommonWordList').then(res => {
      const { code, data } = res.data
      if (code === 200) {
        this.listAbnormalWords = data
      }
    })
  },
  // watch: {
  //   'formScreen.internalConveyNumber'(val) {
      
  //   }
  // },
  methods: {
    // 设置默认时间范围为近12月
    setDefaultDateRange() {
      const endDate = new Date();
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 12);

      // 格式化日期为 yyyy-MM-dd HH:mm:ss
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

      this.formScreen.startTimeString = formatDate(startDate);
      this.formScreen.endTimeString = formatDate(endDate);
    },
    handleChange(row) {
        ajaxPost(
				Baseurl + 'additionalLogisticsInfoController/updateAdditionalLogistics', {
				id: row.id,
				receivedQuantity: row.receivedQuantity,
			}).then((res) => {
				if (res.data.code == 200) {
					this.$message.success(res.data.data)
				} else {
          this.$message.error(res.data.data || res.data.message)
        }
			})
    },
    selectAdditionalLogistics(val) {
      if(val) {
        ajaxPost(
          Baseurl + 'additionalLogisticsInfoController/selectAdditionalLogisticsByInternalConveyNumber', {
          internalConveyNumber: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.gridData = res.data.data
            if (this.gridData.length > 0) {
              this.additional = true
            } else {
              this.additional = false
            }
          } else {
            this.$message.error(res.data.data || res.data.message)
          }
        })
      } else {
        this.additional = false
      }
     
    },
    getTotalNum(val) {
      this.estimatedQuantity = 0
      if (val) {
        var obj = {
          internalConveyNumber: val
        }
        ajaxPost(
          Baseurl + 'logisticsInformationController/selectLogisticsInformation',
          obj
        ).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data) {
              if (res.data.data.receivedQuantity) {
                this.isReceivedQuantity = false
                this.estimatedId = res.data.data.id
                this.receivedQuantity = Number(res.data.data.receivedQuantity)
              } else if (res.data.data.estimatedQuantity) {
                this.isReceivedQuantity = true
                this.receivedQuantity = Number(res.data.data.estimatedQuantity)
              }
              if (res.data.data.estimatedQuantity) {
                this.estimatedId = res.data.data.id
                this.estimatedQuantity = Number(res.data.data.estimatedQuantity)
              }
              if (res.data.data.excessQuantity) {
                this.excessQuantity = res.data.data.excessQuantity
              }
            }
          } else {
            this.$message.error(res.data.data || res.data.message)
          }
        })
      }
    },
    //订单、订单号标签
    orderTag() {
      var obj = { itemCode: 'HYXUN0000010' }
      ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
        (res) => {
          if (res.data.code == 200) {
            let obj = {};
            res.data.data.forEach(item => {
              obj[item.itemTypeId] = item
            });
            this.colorList4 = obj;
            // this.sortByKey(this.colorList4, 'itemTypeIdInteger')
          }
        }
      )
    },
    //订单类型标签
    ordertypeTag() {
      var obj = { itemCode: 'HYXUN0000015' }
      ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
        (res) => {
          if (res.data.code == 200) {
            let obj = {};
            res.data.data.forEach(item => {
              obj[item.itemTypeId] = item
            });
            this.colorList5 = obj;
            // this.sortByKey(this.colorList4, 'itemTypeIdInteger')
          }
        }
      )
    },
    changeRadio() {
      // console.log(val)
      // if (this.pageRadio !== val) {
      //     this.page = 1
      //     this.size = 20
      // }
      if (this.pageRadio === '1') {
        this.getTableData(true);
      } else {
        this.getTableData2(true);
      }
    },
    selectChange(id) {
      this.formData.listSon = [];
      this.formScreen.companyId = "";
      this.getSonCompanyList(id);
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.formData.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.formData.listSon = data;
        }
      });
    },
    searchForm() {
      this.page = 1
      this.changeRadio();
      this.getTotalNum(this.formScreen.internalConveyNumber)
      this.selectAdditionalLogistics(this.formScreen.internalConveyNumber)
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      // 清空日期范围
      this.formScreen.startTimeString = "";
      this.formScreen.endTimeString = "";
      this.estimatedQuantity = 0
      this.estimatedId = ''
      this.receivedQuantity = 1
      this.excessQuantity = 0
      this.formData.listSon = []
      this.additional = false
      this.changeRadio();
    },
    edit(row) {
      this.renderComponent = true;
      // this.getBagList(row.source)
      // console.log(this.bagList);
      this.$refs.Informationcheck.init("confirm", row);

    },
    edit2(row) {
      // this.getBagList(row.source)
      this.renderComponent = true;
      this.getBagList(row.source)
      this.$refs.Informationcheck.init("enter", row);
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.size = val;
      this.changeRadio();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.changeRadio();
    },
    channelChangeConfirm(data) {
      const API = Baseurl + "logisticsController/updateOrderChannelResult";
      const paramsData = {
        roleId: this.UserInfo.rid,
        ...data,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        this.$refs.Informationcheck.isDoneBtnLoding = false;
        if (code === 200) {
          this.$message.success("操作成功");
          this.$refs.Informationcheck.close();
          this.getTableData();
        } else {
          this.$message.error(data);
        }
      });
    },
    channelChangeConfirm2(data) {
      const API = Baseurl + "logisticsController/inventoryCheck";
      const paramsData = {
        roleId: this.UserInfo.rid,
        ...data,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        this.$refs.Informationcheck.isDoneBtnLoding = false;
        if (code === 200) {
          this.$message.success("操作成功");
          this.$refs.Informationcheck.close();
          this.getTableData2();
        } else {
          this.$message.error(data);
        }
      });
    },
    getTableData(isFirst = false) {
      const API = Baseurl + "logisticsController/getLogisticsOrderList";
      const paramsData = {
        page: this.page,
        size: this.size,
        ...this.formScreen,
      };
      if (this.formScreen.searchStrs) {
        this.$set(paramsData, 'searchStrList', this.formScreen.searchStrs.split(' '))
      } else {
        this.$set(paramsData, 'searchStrList', [])
      }
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data;
        if (code === 200) {
          this.listTable = data.list;
          this.total = data.total;
        }
      });

      // if (isFirst) this.getBagList("");
    },
    getTableData2() {
      const API = Baseurl + "logisticsController/getLogisticsInventoryList";
      const paramsData = {
        page: this.page,
        size: this.size,
        ...this.formScreen,
      };
      if (this.formScreen.searchStrs) {
        this.$set(paramsData, 'searchStrList', this.formScreen.searchStrs.split(' '))
      } else {
        this.$set(paramsData, 'searchStrList', [])
      }
      this.loadingTable2 = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable2 = false
        const { code, data } = res.data;
        if (code === 200) {
          this.listTable2 = data.list;
          this.total = data.total;
        }
      });
    },
    getBagList(row) {
      const API = Baseurl + "priceSettingController/getPriceSettingListByType";
      const paramsData = {
        priceType: "3",
        companyId: this.UserInfo.company_id,
      };

      ajaxPost(API, paramsData).then(res => {
        this.bagList = []
        const { code, data } = res.data;
        if (code === 200) {
          if (row === "" || row === null) {
            this.bagList = data;
          } else {
            for (var i = 0; i < data.length; i++) {
              if (data[i].sellerType === row) {
                this.bagList.push(data[i]);
              }
            }
            this.renderComponent = true;
          }

        }
      });
    },
    Warehousing() {
      this.$refs.Warehousing.init();
    },
    // 入库保存
    WarehousingConfirm(data) {
      const API = Baseurl + "logisticsController/purchasePutStorage";
      const purchases = JSON.parse(JSON.stringify(data));
      purchases.forEach(item => {
        delete item.isEdit;
        delete item.id;
      });
      const paramsData = {
        companyId: this.UserInfo.company_id,
        roleId: this.UserInfo.rid,
        purchases,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          const { correctCount, errorCount } = data
          this.$refs.Warehousing.closeLoading();
          this.changeRadio();
          this.$message.success(`共${correctCount + errorCount}条，成功入库${correctCount}条，失败${errorCount}条。`);
        } else {
          this.$message.error("操作有误");
        }
      });
    },
    unkonwnClick() {
      const API = Baseurl + "logisticsController/getUnknownPurchaseList";

      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listUnknown = data;
          this.dialogTableVisible = true;
        }
      });
    },
    delUnknown(val) {
      this.$confirm('确定要删除吗？', '提示').then(() => {
        const API = Baseurl + "logisticsController/deleteUnknownPurchase";
        const paramsData = { id: val.id };
        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data;
          if (code === 200) {
            this.$message.success("删除成功！");
            this.unkonwnClick();
          } else {
            this.$message.error("删除失败！");
          }
        });
      })
    },
    clearUnknown() {
      this.$confirm('确定要清空吗？', '提示').then(() => {
        const API = Baseurl + "logisticsController/emptyUnknownPurchase";
        const paramsData = {
          unknownPurchases: this.listUnknown.map(item => ({ id: item.id })),
        };
        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data;
          if (code === 200) {
            this.$message.success("操作成功！");
            this.unkonwnClick();
          } else {
            this.$message.error("操作错误！");
          }
        });
      })
    },
    getOriginalImg(item) {
      // console.log(item)
      const API = Baseurl + 'productController/selectImagesByChildSku'
      const paramsData = {
        childSku: item.sellerSKU
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data, message } = res.data
        if (code === 200) {
          this.originalImg = data
          this.originalVisible = true
        } else {
          this.$message.error(message)
        }
      })
    },
    orderIdchange(val) {
      const API = Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
      const paramsData = {
        orderId: val.orderId
      }
      ajaxPost(API, paramsData).then(res => {
        if (res.data.code === 200) {
          this.RemarkList = res.data.data
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    saveQuantity() {
      const API = Baseurl + 'logisticsInformationController/editLogisticsInformation'
      const paramsData = {
        id: this.estimatedId,
        internalConveyNumber: this.formScreen.internalConveyNumber,
        receivedQuantity: this.receivedQuantity,
        excessQuantity: this.excessQuantity,
        estimatedQuantity: this.estimatedQuantity
      }
      ajaxPost(API, paramsData).then(res => {
        if (res.data.code === 200) {
          this.$message.success('保存成功')
          this.getTotalNum(this.formScreen.internalConveyNumber)
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    setExceptionRemark(e) {
      this.ruleForm.textarea = e
      this.abnormalContent = ''
    },
    handleAvatarSuccess(file, fileList) {
      this.imageData.push(file);
    },
    handleRemove(file, fileList) {
      this.imageData = [];
      for (var i = 0; i < fileList.length; i++) {
        this.imageData.push(fileList[i].response);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl1 = file.url;
      this.dialogVisible1 = true;
    },
    closeWeizhi(formName) {
      this.dialogVisible = false
      this.imageData = []
      this.$refs.upload.clearFiles();
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          for (var i = 0; i < this.imageData.length; i++) {
            this.arrimage.push(this.imageData[i].data);
          }
          if (this.arrimage.length == 0) {
            this.$message.error('请上传未知库存的运单截图');
          } else {
            let internalConveyNumber = this.ruleForm.DomesticWaybill.replace(/\s+/g, "");
            // return;
            var obj = {
              roleId: this.UserInfo.rid,
              companyId: this.ruleForm.Notify,
              internalConveyNumber,
              unknownDescription: this.ruleForm.textarea,
              unknownImages: this.arrimage
            }
            ajaxPost(Baseurl + "unknownManageController/insertUnknownManage", obj).then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: '创建未知提交成功',
                  type: 'success'
                });
                this.getTableData()
              } else {
                this.$message.error(res.data.data);
              }
              this.$refs.upload.clearFiles();
              this.imageData = []
              this.arrimage = []
              this.$refs[formName].resetFields();
              this.dialogVisible = false
            });
          }
        } else {
          return false;
        }
      });
    },
    openWeizhi() {
      this.ruleForm.DomesticWaybill = this.formScreen.internalConveyNumber
      this.dialogVisible = true
    },
    // 打开修复弹窗
    openFixDialog() {
      this.fixForm.orderNumber = ""
      this.fixDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.fixForm) {
          this.$refs.fixForm.clearValidate()
        }
      })
    },
    // 尝试修复
    tryFix() {
      this.$refs.fixForm.validate((valid) => {
        if (valid) {
          this.fixLoading = true
          const API = Baseurl + "logisticsController/information_tracking_number_try_fix"
          const paramsData = {
            orderNumber: this.fixForm.orderNumber
          }

          ajaxPost(API, paramsData).then(res => {
            this.fixLoading = false
            const { code, message } = res.data
            if (code === 200) {
              this.$message.success('修复成功!')
              this.fixDialogVisible = false
              // 刷新列表
              this.changeRadio()
            } else {
              this.$message.error(message || '修复失败!')
            }
          }).catch(() => {
            this.fixLoading = false
            this.$message.error('请求失败，请稍后重试!')
          })
        } else {
          return false
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.confirm {
  padding-bottom: 72px;

  .pagination-container {
    width: 1660px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }
}

.cell {
  .scope_img {
    display: initial;
  }

  .scope_img img {
    width: 50px;
    height: 50px;
  }
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.details_left {
  width: 30%;
  text-align: center;
}

.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.confirm /deep/ .el-tag--dark {
  border: 0;
}

/deep/.red.el-input-number {
  .el-input__inner {
    color: red !important;
  }
}
</style>
